import { z } from "zod/v4";

const formEditStroskovnoMestoSchema = z.object({
  stroskovnoMesto: z.string().nonempty("Stroškovno mesto je obvezen podatek"),
  stroskovniNosilec: z
    .string()
    .nonempty("Stroškovni nosilec je obvezen podatek"),
});

export default formEditStroskovnoMestoSchema;
